export default __webpack_public_path__ + "static/production5-441df28bf37f5ec7f14a84d054535a92.jpg";